module.exports = __webpack_public_path__ + "static/img/swiperitem01.a5bd1ce7.jpg";